module.exports = __webpack_public_path__ + "static/media/2.1_preview.c30b3231.png";